<template>
    <div class="columns">
        <div class="column is-12-mobile is-12-desktop is-12-widescreen">
            <div class="level">
                <div class="level-left">
                    <div class="title is-marginless is-paddingless">EFT manual matching
                        <span v-if="is_loading || fetching_data" class="button is-white has-text-right preloader" :class="{'is-loading': (is_loading || fetching_data)}"></span>
                    </div>
                </div>
            </div>
            <div class="columns" v-if="!is_loading">
                <div class="column padding-left-0 padding-bottom-0">
                    <div class="has-text-left">
                        <h3 class="has-text-weight-bold" v-html="search_message"></h3>
                    </div>
                </div>
            </div>
            <div class="level" v-if="!is_loading">
                <table class="table is-size-7-touch is-marginless is-fullwidth">
                    <thead>
                    <tr>
                        <td class="is-hidden-mobile s-narrow pad70-desktop is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey">Date</td>
                        <td class="is-narrow-mobile is-hidden-mobile pad35-desktop is-desktop is-size-7-desktop has-text-weight-bold has-text-grey">Payment Reference</td>
                        <td class="is-narrow-mobile pad90-desktop is-size-7-desktop has-text-weight-bold has-text-grey">Amount Paid</td>
                        <td class="is-narrow-mobile is-size-7-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Reference Number</td>
                        <td></td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="(is_loading && items.length === 0) || (!fetching_data && items.length === 0)">
                        <td class="is-narrow pad70-desktop is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey" colspan="7">
                            <p class="has-text-centered is-padded-20">No results found</p>
                        </td>
                    </tr>
                    <tr class="margin-bottom-20" v-if="items.length > 0" v-for="(payment, index) in items">
                        <td class="is-hidden-mobile is-size-7-mobile is-size-7-touch">{{payment.transaction_datetime}}</td>
                        <td class="is-narrow-mobile is-hidden-mobile is-desktop is-size-7-mobile is-size-7-touch">{{payment.payment_reference}}</td>
                        <td class="is-narrow-mobile is-desktop is-size-7-mobile is-size-7-touch">R{{payment.amount}}</td>
                        <td class="is-desktop is-size-7-mobile is-size-7-touch">
                            <span class="control">
                                <input :ref="`payref_${payment.id}`" @keyup="btnToggle(payment.id)" class="color-58595b input is-size-7-touch"/>
                            </span>
                        </td>
                        <td>
                            <button @click.prevent="matchPayment(payment, index, $event)" :ref="`payment_${payment.id}`"
                                    disabled class="button is-button-blue is-hidden-mobile is-fullwidth">SAVE</button>
                            <button @click.prevent="matchPayment(payment, index, $event)" :ref="`payment_${payment.id}`"
                                    disabled class="button-mobile is-button-blue is-hidden-tablet circle-border is-hidden-widescreen">
                                <i class="fas fa-check"></i></button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="level">
                <paginator :dataSet="dataSet" @changed="getUnmatchedNotifications"></paginator>
            </div>
        </div>
    </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
  import axios from 'axios'
  import Paginator from './../../components/Paginator.vue'
  import misc from '../../mixins/misc.js'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - EFT manual matching'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'EFT manual matching'
      })
    },
    components: {Paginator},
    mixins: [misc],
    data () {
      return {
        is_loading: true,
        fetching_data: false,
        search_message: undefined,
        items: [],
        dataSet: {},
        page: undefined,
        total_records: 0
      }
    },
    created () {
      this.getUnmatchedNotifications(null)
    },
    methods: {
      /**
       * Hides or shows the corresponding CTA btn for an input field for entering payment reference to match against
       * @param {integer} source notification id
       * @returns {void}
       */
      btnToggle (source) {
        let btn = this.$refs['payment_' + source]
        let input = this.$refs['payref_' + source][0]
        if (input.value.length > 0) {
          btn.forEach((element) => {
            element.disabled = false
          })
        } else {
          btn.forEach((element) => {
            element.disabled = true
          })
        }
      },
      /**
       * Makes a call to api to manually match a payment to an invoice.
       * @param {object} payment record
       * @param {integer} index index of onboard in items collection
       * @param {event} event record to activate
       * @returns {void}
       */
     matchPayment (payment, index, event) {
        let element = event.target
        if (element.parentElement.localName === 'a') {
          element = event.target.parentElement
        }
        element.classList.add('is-loading')
        let parent = this
        let payload = {notification_id: payment.id, payment_reference: this.$refs['payref_' + payment.id][0].value}
        axios.post(`/billing/match-eft-payment`, payload)
            .then(() => {
              element.classList.remove('is-loading')
              parent.btnToggle(payment.id)

              if (this.items.length === 0 && this.page > 1) {
                this.getUnmatchedNotifications(this.page - 1)
              } else {
                this.getUnmatchedNotifications(this.page)
              }
              this.$refs['payref_' + payment.id][0].value = ''
              this.$refs['payment_' + payment.id][0].disabled = true
              this.items.splice(index, 1)
              flash('Payment successfully linked to invoice.')
            })
            .catch((error) => {
              element.classList.remove('is-loading')
              console.log(error)
              flash('Payment couldn\'t be successfully linked to invoice. Try again later', 'is-danger')
            })
      },
      /**
       * Make request to api to get unmatched eft records.
       * @returns {number | null}
       * @param {number} page page number to paginate to
       */
      getUnmatchedNotifications (page) {
        this.page = page
        this.fetching_data = true
        axios.get(this.url(page))
            .then((response) => {
              this.refresh(response, 'eft-matching')
              this.is_loading = false
              this.fetching_data = false
            })
            .catch(() => {
              flash('You are not authorized to view this resource.', 'is-danger')
              this.is_loading = false
              this.fetching_data = false
            })
      },
      /**
       * Compute URI to make call to api with.
       * @param {string} page starting page to request
       * @return {string}
       */
      url (page) {
        if (!page) {
          let query = location.search.match(/page=(\d+)/)

          page = query ? query[1] : 1
        }

        return `/billing/unmatched-eft-notifications?page=${page}`
      }
    }
  }
</script>

<style scoped>
    .table td, .table th {
        border: none;
    }

    .table > tbody > tr {
        background-color: #f5f5f5 !important;
        margin-bottom: 10px;
    }

    .table > tbody > td {
        margin-bottom: 20px;
    }

    .color-58595b {
        color:#58595b;
    }
    .input {
        font-size: 10pt;
    }
</style>


// WEBPACK FOOTER //
// src/pages/billing/EFTManualMatching.vue